<script>
    import {
        generateEmployeeCardForMonth,
        showDialog,
        dialogType,
        dialogMessage
    } from "../http";

    export let employee;

    let isDialogOpen = false;
    let isDownloading = false;
    let selectedMonth;
    let selectedYear;

    const getDefaultPeriod = () => {
        const now = new Date();
        let month = now.getMonth() + 1;
        let year = now.getFullYear();

        if (month === 1) {
            month = 12;
            year -= 1;
        } else {
            month -= 1;
        }

        return { month, year };
    };

    const openDialog = () => {
        const defaults = getDefaultPeriod();
        selectedMonth = employee?.month ?? defaults.month;
        selectedYear = employee?.year ?? defaults.year;
        isDialogOpen = true;
    };

    const closeDialog = () => {
        if (!isDownloading) {
            isDialogOpen = false;
        }
    };

    const downloadCard = async () => {
        if (!employee) {
            return;
        }

        isDownloading = true;
        try {
            await generateEmployeeCardForMonth(
                employee.employee_email,
                selectedMonth,
                selectedYear
            );
            isDialogOpen = false;
        } catch (error) {
            showDialog.set(true);
            dialogType.set("is-danger");
            dialogMessage.set("Nie możemy pobrać karty pracownika. Spróbuj ponownie.");
        } finally {
            isDownloading = false;
        }
    };

    const months = [
        { value: 1, label: "Styczeń" },
        { value: 2, label: "Luty" },
        { value: 3, label: "Marzec" },
        { value: 4, label: "Kwiecień" },
        { value: 5, label: "Maj" },
        { value: 6, label: "Czerwiec" },
        { value: 7, label: "Lipiec" },
        { value: 8, label: "Sierpień" },
        { value: 9, label: "Wrzesień" },
        { value: 10, label: "Październik" },
        { value: 11, label: "Listopad" },
        { value: 12, label: "Grudzień" }
    ];

    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
</script>

<button
    class="button is-info has-text-weight-bold my-2"
    type="button"
    on:click={openDialog}
>
    Pobierz kartę pracownika
</button>

{#if isDialogOpen}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeDialog}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Pobierz kartę pracownika</p>
                <button class="delete" aria-label="close" on:click={closeDialog}></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">Miesiąc</label>
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select bind:value={selectedMonth}>
                                {#each months as month}
                                    <option value={month.value}>{month.label}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label">Rok</label>
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select bind:value={selectedYear}>
                                {#each years as year}
                                    <option value={year}>{year}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button
                    class="button is-info"
                    class:is-loading={isDownloading}
                    disabled={isDownloading}
                    on:click={downloadCard}
                >
                    Pobierz
                </button>
                <button class="button" type="button" on:click={closeDialog}>Anuluj</button>
            </footer>
        </div>
    </div>
{/if}
